import { MapPinIcon as PhosphorMapPinIcon } from "@phosphor-icons/react/dist/ssr/MapPin";

import { createAppIcon } from "@/components/createAppIcon";

export const LocationIcon = /* @__PURE__ */ createAppIcon(PhosphorMapPinIcon);
